// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "motorcycle-summer-gloves",
  "entries": [
    {
      "id": "33377282162878",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-11.jpg?v=1783418541",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 11"
    },
    {
      "id": "33377281835198",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-01.jpg?v=1783418541",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 01"
    },
    {
      "id": "33377281867966",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-02.jpg?v=1783418541",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 02"
    },
    {
      "id": "33377281900734",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-03.jpg?v=1783418541",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 03"
    },
    {
      "id": "33377281933502",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-04.jpg?v=1783418542",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 04"
    },
    {
      "id": "33377281966270",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-05.jpg?v=1783418542",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 05"
    },
    {
      "id": "33377281999038",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-06.jpg?v=1783418542",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 06"
    },
    {
      "id": "33377282031806",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-07.jpg?v=1783418542",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 07"
    },
    {
      "id": "33377282064574",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-08.jpg?v=1783418542",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 08"
    },
    {
      "id": "33377282097342",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-09.jpg?v=1783418542",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 09"
    },
    {
      "id": "33377282130110",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-10.jpg?v=1783418542",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 10"
    },
    {
      "id": "33377282195646",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-12.jpg?v=1783418542",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 12"
    },
    {
      "id": "33377282228414",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-13.jpg?v=1783418542",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 13"
    },
    {
      "id": "33377282261182",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-14.jpg?v=1783418542",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 14"
    },
    {
      "id": "33377282293950",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-15.jpg?v=1783418541",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 15"
    },
    {
      "id": "33377282326718",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-16.jpg?v=1783418542",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 16"
    },
    {
      "id": "33377282359486",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-17.jpg?v=1783418542",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 17"
    },
    {
      "id": "33377282392254",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-18.jpg?v=1783418543",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 18"
    },
    {
      "id": "33377282425022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-19.jpg?v=1783418542",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 19"
    },
    {
      "id": "33377282457790",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-20.jpg?v=1783418542",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 20"
    },
    {
      "id": "33377282490558",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-21.jpg?v=1783418541",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 21"
    },
    {
      "id": "33377282523326",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-22.jpg?v=1783418541",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 22"
    },
    {
      "id": "33377282556094",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-23.jpg?v=1783418542",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 23"
    },
    {
      "id": "33377282588862",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-24.jpg?v=1783418542",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 24"
    },
    {
      "id": "33377282621630",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-25.jpg?v=1783418542",
      "alt": "color:all | Seibertron SPS-5 half finger motorcycle gloves common image 25"
    },
    {
      "id": "33377282654398",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-adult-half-finger-gallery-26.jpg?v=1783418542",
      "alt": "color:all | Seibertron SPS-5 half finger motorcycle gloves common image 26"
    }
  ],
  "variants": [
    {
      "id": "42861911048382",
      "title": "Black / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "Black",
        "S"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911081150",
      "title": "Black / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "Black",
        "M"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911113918",
      "title": "Black / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "Black",
        "L"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911146686",
      "title": "Black / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "Black",
        "XL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911179454",
      "title": "Black / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "Black",
        "XXL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911212222",
      "title": "Black / XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "Black",
        "XXXL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "42861911244990",
      "title": "White / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "White",
        "S"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911277758",
      "title": "White / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "White",
        "M"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911310526",
      "title": "White / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "White",
        "L"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911343294",
      "title": "White / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "White",
        "XL"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911376062",
      "title": "White / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "White",
        "XXL"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911408830",
      "title": "White / XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "White",
        "XXXL"
      ],
      "mediaId": "33377281966270"
    },
    {
      "id": "42861911441598",
      "title": "Orange / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "Orange",
        "S"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "42861911474366",
      "title": "Orange / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "Orange",
        "M"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "42861911507134",
      "title": "Orange / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "Orange",
        "L"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "42861911539902",
      "title": "Orange / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "Orange",
        "XL"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "42861911572670",
      "title": "Orange / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "Orange",
        "XXL"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "42861911605438",
      "title": "Orange / XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Orange"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "Orange",
        "XXXL"
      ],
      "mediaId": "33377282064574"
    },
    {
      "id": "44029348053182",
      "title": "Grey / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "Grey",
        "S"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348085950",
      "title": "Grey / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "Grey",
        "M"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348118718",
      "title": "Grey / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "Grey",
        "L"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348151486",
      "title": "Grey / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "Grey",
        "XL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348184254",
      "title": "Grey / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "Grey",
        "XXL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348217022",
      "title": "Grey / XXXL",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "Grey"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "Grey",
        "XXXL"
      ],
      "mediaId": "33377282162878"
    },
    {
      "id": "44029348249790",
      "title": "Pink / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "Pink",
        "S"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348282558",
      "title": "Pink / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "Pink",
        "M"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348315326",
      "title": "Pink / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "Pink",
        "L"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348348094",
      "title": "Pink / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "Pink",
        "XL"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348380862",
      "title": "Pink / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "Pink",
        "XXL"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348413630",
      "title": "Pink / XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "Pink",
        "XXXL"
      ],
      "mediaId": "33377282293950"
    },
    {
      "id": "44029348446398",
      "title": "FL Yellow / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "S"
        }
      ],
      "values": [
        "FL Yellow",
        "S"
      ],
      "mediaId": "33377282457790"
    },
    {
      "id": "44029348479166",
      "title": "FL Yellow / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "FL Yellow",
        "M"
      ],
      "mediaId": "33377282457790"
    },
    {
      "id": "44029348511934",
      "title": "FL Yellow / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "FL Yellow",
        "L"
      ],
      "mediaId": "33377282457790"
    },
    {
      "id": "44029348577470",
      "title": "FL Yellow / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "FL Yellow",
        "XL"
      ],
      "mediaId": "33377282457790"
    },
    {
      "id": "44029348610238",
      "title": "FL Yellow / XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "FL Yellow",
        "XXL"
      ],
      "mediaId": "33377282457790"
    },
    {
      "id": "44029348643006",
      "title": "FL Yellow / XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "XXXL"
        }
      ],
      "values": [
        "FL Yellow",
        "XXXL"
      ],
      "mediaId": "33377282457790"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {
    "Black": "33377281835198",
    "White": "33377281966270",
    "Orange": "33377282064574",
    "Grey": "33377282162878",
    "Pink": "33377282293950",
    "FL Yellow": "33377282457790"
  },
  "optimizeColorSwatches": true
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
